module.exports = __webpack_public_path__ + "static/custom-logo-wide-a66bda04be0707af512ef00761cc7e5a.png";